module.exports = __webpack_public_path__ + "static/img/charge.089c4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/charge.png
// module id = EQtk
// module chunks = 1